import { useMutation } from '@apollo/client';

import { IMoveHostsRequest, MOVE_HOSTS } from 'schemas';

import { TUseMoveHosts } from './interfaces';

export const useMoveHosts: TUseMoveHosts = () => {
  const [moveHosts] = useMutation<boolean, IMoveHostsRequest>(MOVE_HOSTS);

  return { moveHosts };
};
